import * as React from "react"
const MenuSVG = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={window.screen.width <= 1000 ? '25' : '40'}
    height={window.screen.width <= 1000 ? '25' : '40'}
    viewBox="0 0 30 35"
    fill={'white'}
    {...props}
  >
    <path d="M3 7a1 1 0 1 0 0 2h24a1 1 0 1 0 0-2H3zm0 7a1 1 0 1 0 0 2h24a1 1 0 1 0 0-2H3zm0 7a1 1 0 1 0 0 2h24a1 1 0 1 0 0-2H3z" />
  </svg>
)
export default MenuSVG
